export default __webpack_public_path__ + "static/media/web-design.e679d02c.jpg";